import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { AppSettings } from 'src/app/utils/app-settings';
import { Observable } from 'rxjs';
import { PreSignedUrl } from 'src/app/models/pre-signed-url';
import { UploadFile } from 'src/app/modules/pages/homeworks/models/upload-file';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(public http: HttpClient) { }

  getPresignedUrl(filesToUpload: Array<UploadFile>, destination: string): Observable<Array<PreSignedUrl>> {
    return this.http.post<Array<PreSignedUrl>>(AppSettings.apiUrl + "file/presignedurl/" + destination, filesToUpload);
  }

  uploadFile(fileUploadUrl:string, contentType: string, file: File): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': contentType});
    const req = new HttpRequest(
    'PUT',
    fileUploadUrl,
    file,
    {
      headers: headers,
      reportProgress: true,
    });
    return this.http.request(req);
  }
}
